export type { EmptyStateAction, EmptyStateProps } from '../../types/empty-state';
export { EmptyState } from './adapters/inbound/EmptyState';
